import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { RoleActions } from './role.actions';
import { RoleService } from 'src/app/core/services/role.service';

@Injectable()
export class RoleEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roleService: RoleService
  ) {}

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.listSystemRoles),
      mergeMap(() =>
        from(this.roleService.getRolesNames()).pipe(
          map((response) => RoleActions.listSystemRolesSuccess(response)),
          catchError((error) =>
            of(RoleActions.listSystemRolesFailure({ error: error.message }))
          )
        )
      )
    )
  );

  loadSingleRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.getSingleRole),
      mergeMap(({ id }) =>
        from(this.roleService.getRole(id)).pipe(
          map((response) => RoleActions.getSingleRoleSuccess(response)),
          catchError((error) =>
            of(RoleActions.getSingleRoleFailure({ error: error.message }))
          )
        )
      )
    )
  );
}
